(function(){
  function init(){
    var sections = document.querySelectorAll('.google-reviews');
    sections.forEach(function(section){
      var subtitle = section.querySelector('.subtitle');
      if(!subtitle || subtitle.dataset.ccCarouselDone) return;
      var h5s = Array.prototype.slice.call(subtitle.querySelectorAll('h5')).filter(function(h){ return h.textContent.trim() !== ''; });
      if(h5s.length < 2) return;
      var reviews = [];
      for(var i=0;i<h5s.length;i+=2){
        if(h5s[i+1]) reviews.push({quote: h5s[i].innerHTML, author: h5s[i+1].innerHTML});
      }
      if(!reviews.length) return;
      subtitle.dataset.ccCarouselDone = '1';

      var carousel = document.createElement('div');
      carousel.className = 'cc-reviews-carousel';
      carousel.setAttribute('role','region');
      carousel.setAttribute('aria-roledescription','carousel');
      carousel.setAttribute('aria-label','Customer reviews');
      carousel.setAttribute('tabindex','0');

      var viewport = document.createElement('div');
      viewport.className = 'cc-reviews-viewport';
      var track = document.createElement('div');
      track.className = 'cc-reviews-track';

      reviews.forEach(function(r, idx){
        var slide = document.createElement('div');
        slide.className = 'cc-reviews-slide';
        slide.setAttribute('role','group');
        slide.setAttribute('aria-roledescription','slide');
        slide.setAttribute('aria-label',(idx+1)+' of '+reviews.length);
        slide.setAttribute('aria-hidden', idx===0 ? 'false' : 'true');

        var quote = document.createElement('blockquote');
        quote.className = 'cc-reviews-quote';
        quote.innerHTML = r.quote;

        var cite = document.createElement('cite');
        cite.className = 'cc-reviews-author';
        cite.innerHTML = r.author;

        slide.appendChild(quote);
        slide.appendChild(cite);
        track.appendChild(slide);
      });

      viewport.appendChild(track);
      carousel.appendChild(viewport);

      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'cc-reviews-arrow cc-reviews-arrow--prev';
      prevBtn.setAttribute('aria-label','Previous review');
      prevBtn.innerHTML = '&#8249;';

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'cc-reviews-arrow cc-reviews-arrow--next';
      nextBtn.setAttribute('aria-label','Next review');
      nextBtn.innerHTML = '&#8250;';

      carousel.appendChild(prevBtn);
      carousel.appendChild(nextBtn);

      var dots, dotEls = [];
      if(reviews.length > 1){
        dots = document.createElement('div');
        dots.className = 'cc-reviews-dots';
        dots.setAttribute('role','tablist');
        dots.setAttribute('aria-label','Choose a review');
        reviews.forEach(function(r, idx){
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cc-reviews-dot' + (idx===0 ? ' is-active' : '');
          dot.setAttribute('role','tab');
          dot.setAttribute('aria-label','Review '+(idx+1)+' of '+reviews.length);
          dot.setAttribute('aria-selected', idx===0 ? 'true' : 'false');
          dot.addEventListener('click', function(){ goTo(idx); });
          dots.appendChild(dot);
        });
        carousel.appendChild(dots);
        dotEls = Array.prototype.slice.call(dots.children);
      }

      var live = document.createElement('span');
      live.setAttribute('aria-live','polite');
      live.style.position='absolute';
      live.style.width='1px';
      live.style.height='1px';
      live.style.overflow='hidden';
      live.style.clip='rect(0 0 0 0)';
      carousel.appendChild(live);

      subtitle.style.display = 'none';
      subtitle.insertAdjacentElement('afterend', carousel);

      var current = 0;
      var slides = Array.prototype.slice.call(track.children);

      function render(){
        track.style.transform = 'translateX(-' + (current*100) + '%)';
        slides.forEach(function(s, i){
          s.setAttribute('aria-hidden', i===current ? 'false' : 'true');
        });
        dotEls.forEach(function(d, i){
          d.classList.toggle('is-active', i===current);
          d.setAttribute('aria-selected', i===current ? 'true' : 'false');
        });
        live.textContent = 'Showing review '+(current+1)+' of '+reviews.length;
      }

      function goTo(idx){
        current = (idx + reviews.length) % reviews.length;
        render();
      }

      prevBtn.addEventListener('click', function(){ goTo(current-1); });
      nextBtn.addEventListener('click', function(){ goTo(current+1); });

      if(reviews.length < 2){
        prevBtn.style.display='none';
        nextBtn.style.display='none';
      }

      carousel.addEventListener('keydown', function(e){
        if(e.key === 'ArrowLeft'){ goTo(current-1); }
        else if(e.key === 'ArrowRight'){ goTo(current+1); }
      });

      var touchStartX = null;
      viewport.addEventListener('touchstart', function(e){
        touchStartX = e.touches[0].clientX;
      }, {passive:true});
      viewport.addEventListener('touchend', function(e){
        if(touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if(Math.abs(dx) > 40){
          if(dx < 0) goTo(current+1); else goTo(current-1);
        }
        touchStartX = null;
      }, {passive:true});

      var ctaLink = section.querySelector('.google_reviews_btn a');
      if(ctaLink){
        ctaLink.classList.remove('button','button--primary');
        ctaLink.classList.add('cc-review-cta');
        ctaLink.textContent = 'Leave us a review \u2192';
      }

      render();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
